module.exports = __webpack_public_path__ + "img/fabric-slide-1-xxl.a855881.webp";